import { render, staticRenderFns } from "./JobToDo.vue?vue&type=template&id=1a827582&scoped=true"
import script from "./JobToDo.vue?vue&type=script&lang=js"
export * from "./JobToDo.vue?vue&type=script&lang=js"
import style0 from "./JobToDo.vue?vue&type=style&index=0&id=1a827582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a827582",
  null
  
)

export default component.exports